<div
  class="application-review d-flex flex-column justify-content-between align-items-start align-items-lg-center align-items-md-center bg-white">
  <div
    class="header text-start text-lg-center text-md-center pb-4 d-none d-lg-block d-md-block">
    <h3>{{ 'Review and finish up' | translate }}</h3>
    <p>
      {{
        "You're almost ready to submit your application. Take a moment to review and confirm your information"
          | translate
      }}
    </p>
  </div>
  <div
    class="d-flex flex-column flex-lg-row gap-lg-4 justify-content-between content-body">
    <div class="col-12 col-lg-8 col-md-8 overflow-y-scroll form-fields">
      <ng-container
        *ngFor="let data of formData; let index = index; trackBy: trackByFn">
        <!-- Regular section or Service section header -->
        <div class="d-flex justify-content-between py-3">
          <p class="text-start d-inline-block block-name">
            {{ index + 1 }}.
            {{
              data.formGroupName.charAt(0).toUpperCase() +
                data.formGroupName.slice(1).toLowerCase()
            }}
          </p>
          <div>
            <i>
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <rect width="20" height="20" rx="10" fill="#079455" />
                <path
                  d="M6.25 10L8.75 12.5L13.75 7.5"
                  stroke="white"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </i>
          </div>
        </div>

        <!-- Service sections handling -->
        <ng-container *ngIf="data.isService; else regularSection">
          <!-- Loop through service internal sections -->
          <ng-container
            *ngFor="
              let serviceSection of data.nestedSections;
              let serviceIndex = index
            ">
            <!-- Nested service section with same styling as regular sections -->
            <div class="ms-4">
              <div class="d-flex justify-content-between py-3">
                <p class="text-start d-inline-block block-name">
                  {{ serviceIndex + 1 }}.
                  {{
                    (serviceSection.fieldGroupName || 'Unknown Section')
                      .charAt(0)
                      .toUpperCase() +
                      (serviceSection.fieldGroupName || 'Unknown Section')
                        .slice(1)
                        .toLowerCase()
                  }}
                </p>
                <div>
                  <i>
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <rect width="20" height="20" rx="10" fill="#079455" />
                      <path
                        d="M6.25 10L8.75 12.5L13.75 7.5"
                        stroke="white"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>
                  </i>
                </div>
              </div>
              <div class="rounded-3 border border-secondary mb-3">
                <irembogov-application-generic-form-preview-card
                  [data]="{
                    formGroupName:
                      serviceSection.fieldGroupName || 'Unknown Section',
                    formGroupKey: serviceSection.fieldGroupKey || '',
                    formGroup: [serviceSection]
                  }"
                  [columnSize]="'col-12'">
                </irembogov-application-generic-form-preview-card>
                <div class="divider"></div>
                <div class="px-3">
                  <button (click)="onEdit(index)" class="btn edit-button mb-3">
                    {{ 'Edit' | translate }}
                  </button>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>

        <!-- Regular section template -->
        <ng-template #regularSection>
          <div class="rounded-3 border border-secondary mb-3">
            <irembogov-application-generic-form-preview-card
              [data]="data"
              [columnSize]="'col-12'">
            </irembogov-application-generic-form-preview-card>
            <div class="divider"></div>
            <div class="px-3">
              <button (click)="onEdit(index)" class="btn edit-button mb-3">
                {{ 'Edit' | translate }}
              </button>
            </div>
          </div>
        </ng-template>
      </ng-container>
    </div>
    <div
      class="notifications col-12 col-lg-4 col-md-4 d-flex flex-column justify-content-start align-items-start p-3 border border-secondary rounded-3 align-self-start sticky-top">
      <h4>
        {{
          'Where would you like us to send notifications about this application?'
            | translate
        }}
      </h4>
      <span>{{
        'We will send notifications to the applicant via' | translate
      }}</span>
      <div class="d-flex flex-column justify-content-start w-100 pt-3">
        <form
          [formGroup]="notificationForm"
          class="container-fluid d-flex flex-column justify-content-center align-items-start">
          <div class="form-check w-100 mb-3">
            <input
              class="form-check-input"
              type="checkbox"
              id="phone_number"
              formControlName="smsCheckbox" />
            <label class="form-check-label mb-2" for="phone_number">{{
              'Send to phone number' | translate
            }}</label>
            <div
              *ngIf="notificationForm.get('smsCheckbox')?.value"
              class="input-container">
              <i>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M6.98356 7.37779C7.56356 8.58581 8.35422 9.71801 9.35553 10.7193C10.3568 11.7206 11.4891 12.5113 12.6971 13.0913C12.801 13.1412 12.8529 13.1661 12.9187 13.1853C13.1523 13.2534 13.4392 13.2045 13.637 13.0628C13.6927 13.0229 13.7403 12.9753 13.8356 12.88C14.1269 12.5887 14.2726 12.443 14.4191 12.3478C14.9715 11.9886 15.6837 11.9886 16.2361 12.3478C16.3825 12.443 16.5282 12.5887 16.8196 12.88L16.9819 13.0424C17.4248 13.4853 17.6462 13.7067 17.7665 13.9446C18.0058 14.4175 18.0058 14.9761 17.7665 15.449C17.6462 15.6869 17.4248 15.9083 16.9819 16.3512L16.8506 16.4825C16.4092 16.9239 16.1886 17.1446 15.8885 17.3131C15.5556 17.5001 15.0385 17.6346 14.6567 17.6334C14.3126 17.6324 14.0774 17.5657 13.607 17.4322C11.0792 16.7147 8.69387 15.361 6.70388 13.371C4.7139 11.381 3.36017 8.99569 2.6427 6.46786C2.50919 5.99749 2.44244 5.7623 2.44141 5.41818C2.44028 5.03633 2.57475 4.51925 2.76176 4.18633C2.9303 3.88631 3.15098 3.66563 3.59233 3.22428L3.72369 3.09292C4.16656 2.65005 4.388 2.42861 4.62581 2.30833C5.09878 2.0691 5.65734 2.0691 6.1303 2.30832C6.36812 2.42861 6.58955 2.65005 7.03242 3.09291L7.19481 3.25531C7.48615 3.54665 7.63182 3.69231 7.72706 3.8388C8.08622 4.3912 8.08622 5.10336 7.72706 5.65576C7.63182 5.80225 7.48615 5.94791 7.19481 6.23925C7.09955 6.33451 7.05192 6.38214 7.01206 6.43782C6.87038 6.63568 6.82146 6.92256 6.88957 7.15619C6.90873 7.22193 6.93367 7.27389 6.98356 7.37779Z"
                    stroke="#A4A7AE"
                    stroke-width="1.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </i>
              <input
                class="input-with-icon"
                type="tel"
                formControlName="phone_number"
                placeholder="07XXXXXXXX" />
              <div
                *ngIf="
                  notificationForm.get('phone_number')?.invalid &&
                  notificationForm.get('phone_number')?.touched
                "
                class="text-danger small mt-1">
                {{
                  'Enter a valid Rwandan phone number starting with 07 (e.g. 0781234567)'
                    | translate
                }}
              </div>
            </div>
          </div>

          <div class="form-check w-100">
            <input
              class="form-check-input"
              type="checkbox"
              id="email"
              formControlName="emailCheckbox" />
            <label class="form-check-label mb-2" for="email">{{
              'Send to email' | translate
            }}</label>
            <div
              *ngIf="notificationForm.get('emailCheckbox')?.value"
              class="input-container">
              <i>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M1.6665 5.8335L8.4706 10.5964C9.02158 10.982 9.29707 11.1749 9.59672 11.2496C9.86142 11.3156 10.1383 11.3156 10.403 11.2496C10.7026 11.1749 10.9781 10.982 11.5291 10.5964L18.3332 5.8335M5.6665 16.6668H14.3332C15.7333 16.6668 16.4334 16.6668 16.9681 16.3943C17.4386 16.1547 17.821 15.7722 18.0607 15.3018C18.3332 14.767 18.3332 14.067 18.3332 12.6668V7.3335C18.3332 5.93336 18.3332 5.2333 18.0607 4.69852C17.821 4.22811 17.4386 3.84566 16.9681 3.60598C16.4334 3.3335 15.7333 3.3335 14.3332 3.3335H5.6665C4.26637 3.3335 3.56631 3.3335 3.03153 3.60598C2.56112 3.84566 2.17867 4.22811 1.93899 4.69852C1.6665 5.2333 1.6665 5.93336 1.6665 7.3335V12.6668C1.6665 14.067 1.6665 14.767 1.93899 15.3018C2.17867 15.7722 2.56112 16.1547 3.03153 16.3943C3.56631 16.6668 4.26637 16.6668 5.6665 16.6668Z"
                    stroke="#A4A7AE"
                    stroke-width="1.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </i>
              <input
                class="input-with-icon"
                type="email"
                formControlName="email" />
              <div
                *ngIf="
                  notificationForm.get('email')?.invalid &&
                  notificationForm.get('email')?.touched
                "
                class="text-danger small mt-1">
                {{ 'Enter a valid email address' | translate }}
              </div>
            </div>
          </div>
        </form>
        <div class="divider"></div>
        <div class="terms">
          <div class="col-12 mb-3">
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                id="gridCheck"
                [(ngModel)]="consent" />
              <label class="form-check-label" for="gridCheck">
                {{
                  'By checking this box, I confirm that all information provided in this application is true, accurate, and up-to-date.'
                    | translate
                }}
              </label>
            </div>
          </div>
          <div class="col-12 mb-3 p-3 rounded-3 note">
            <span
              ><strong>{{ 'Note:' | translate }}</strong
              ><br />
              {{
                'You can not change the information provided after this action.'
                  | translate
              }}</span
            >
          </div>
        </div>
        <div class="text-center">
          <button
            type="button"
            [disabled]="
              isSubmitting ||
              !isNotificationValid() ||
              notificationForm.invalid ||
              !consent
            "
            class="btn btn-primary w-100 rounded-3"
            (click)="onSave()">
            <div
              *ngIf="isSubmitting"
              class="spinner-border spinner-border-sm text-light"
              role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            {{
              !isResubmitting
                ? ('Create application' | translate)
                : ('Resubmit application' | translate)
            }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
